import { Prompt } from '../Prompt/Prompt.component';

interface isCriteriaSetupModalProps {
  open: boolean;
  onClose: () => void;
}

export const EditSchemeScoresDetailsErrorPrompt: React.FC<isCriteriaSetupModalProps> = ({ open, onClose }) => {
  return (
    <Prompt
      type={'warning'}
      open={open}
      size="sm"
      mainActionButtonText={'OK'}
      onConfirm={onClose}
      mainText={`Możliwa edycja nazwy kryterium. Nie można wprowadzić innych zmian do schematu punktowania, ponieważ zostały już skonfigurowane kryteria zależne.`}
    />
  );
};
